import React from 'react'
import './recharge.less'
import { withRouter } from "react-router";
import { setHeader } from '@/util/set-header';
import {  rechargeRoomApi, rechargePayApi, RechargeResultApi } from "@/api/sany";
import { NoticeBar,Tabs,List,Button,Modal,Toast } from "antd-mobile";
import Cookies from "universal-cookie";
import { phonePlatform } from "@/util/util";
const cookie = new Cookies()
const Item = List.Item
const alert = Modal.alert
@(withRouter as any)
export default class Recharge extends React.Component<any,any> {
  // 返回的订单ID
  billId = ''
  isBack = false
  state = {
    tabIndex: 0,
    showTab: false, // 判断该门店是否有热水卡
    checkModal: false,
    showModal: false,
    pay_type: 'wechat',
    fee_type: 1,
    // 输入充值量
    customize:'',
    usageArr:[50,100,200],
    usageWaterArr:[5,10,20],
    // 充值量
    usage:cookie.get('activeTab') ? 5 : 50,
    rechargeInfo: {
      ext_electric_fee: '',  // 电费单价
      ext_coldwater_fee: '', // 水费单价
      electric_remain: '', // 电余量
      water_remain: '', // 水余量
      hot_remain: '', // 热水余量
      room_id: '',
      bed_id: '',
      phone: '',
      electric_switch: false,     // 电表是否在线
      water_switch: false,     // 水是否在线
      hot_switch: false,     // 热水是否在线
      have_electric: true,     // 该房间是否有充值电费权限
      have_water: true,     // 该房间是否有充值水费权限
      have_hot: true,     // 该房间是否有充值热水费权限
      electric_pay: '1',     // 0后付费，1预付费
      water_pay: '1' ,   //0后付费，1预付费
      hot_pay: '1'    //0后付费，1预付费
    }
  }
  constructor(prop: any) {
    super(prop)
    //  支付回调传来的参数
    if (cookie.get('rechargeBillId')) {
      this.isBack = true
      alert('', <div>请确认支付是否完成?</div>, [
        { text: '重新支付', onPress: () => this.resetPay()},
        { text: '支付完成', onPress: () => this.fetchPayResult() },
      ])
    }
    this.getRechageVal(cookie.get('activeTab') || 1)
    this.leftClick = this.leftClick.bind(this)
    this.getTab = this.getTab.bind(this)
    this.getToFixedValue = this.getToFixedValue.bind(this)
  }
  componentDidMount() {
    setHeader({title: '能源费充值',  leftClick: this.leftClick, right: this.rightBtn() })
    if (cookie.get('activeTab') === 2) {
      this.state.tabIndex = 1
      this.state.fee_type = 2
    } else if(cookie.get('activeTab') === 4){
      this.state.tabIndex = 2
      this.state.fee_type = 4
    }
  }
  getTab(tab: any, index: number) {
    console.log(tab, 'tab111', index, 'index8888')
    this.setState({
      tabIndex: index,
      fee_type: tab.sub,
      customize: '',
      usage: index === 0 ? 50 : 5,
    })
    this.getRechageVal(tab.sub)
    if (tab.sub === 2) {
      cookie.set('activeTab', tab.sub)
    } else if (tab.sub === 4) {
      cookie.set('activeTab', tab.sub)
    } else {
      cookie.set('activeTab', '')
    }
  }
  //请求数据
  async getRechageVal(type: any) {
    Toast.loading('实时数据查询中...')
    const {data} = await rechargeRoomApi({store_id: cookie.get('rechargeStoreId'), phone: cookie.get('sany_phone'), fee_type: type, room_id: cookie.get('room_id') })
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.setState({
        rechargeInfo: data.data,
        showTab: data.data.hot_pay === '1' ? true : false
      })
      // 为确保读取的是最新数据，再次请求接口获取数据
      if (this.state.fee_type === 1 && data.data.electric_remain === '0' || this.state.fee_type === 2 && data.data.water_remain === '0' || this.state.fee_type === 4 && data.data.hot_remain === '0') {
        const {data} = await rechargeRoomApi({store_id: cookie.get('rechargeStoreId'), phone: cookie.get('sany_phone'), fee_type: type, room_id: cookie.get('room_id') })
        this.setState({
          rechargeInfo: data.data
        })
      }
      if (this.state.fee_type === 1 && data.data.electric_pay === '1' && data.data.have_electric && data.data.electric_switch) {
        this.setState({
          checkModal: false,
        });
      } else  if (this.state.fee_type === 2 && data.data.water_pay === '1' && data.data.have_water && data.data.water_switch) {
        this.setState({
          checkModal: false,
        });
      } else  if (this.state.fee_type === 4 && data.data.hot_pay === '1' && data.data.have_hot && data.data.hot_switch) {
        this.setState({
          checkModal: false,
        });
      } else {
        this.setState({
          checkModal: true,
        });
      }
    }
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      this.props.history.push({
        pathname: '/sany/dorm-manage',
        state: { id: cookie.get('rechargeListId') }
      })
      cookie.set('rechargeBillId', '')
      cookie.set('activeTab', '')
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }
  rightBtn() {
    return (
      <div onClick={() => this.openUrl()} style={{color: '#e94f4f'}}>
        <img style= {{width:'35px',height:'35px'}} src='https://ncc-godfs.sany.com.cn/group1/default/20210423/22/44/2/下载.png'></img>
      </div>
    )
  }
  openUrl() {
    window.location.replace('https://ncc-intelcc-user.sany.com.cn/?channelKey=8713508c067c870780cc8673a374cf5d&init=1')
  }
  payInfoList() {
    const tabList = [
      { title: '电费', sub: 1 },
      { title: '水费', sub: 2 },
    ];
    const tabLists = [
      { title: '电费', sub: 1 },
      { title: '水费', sub: 2 },
      { title: '热水费', sub: 4 }
    ];
    return (
      <div className="component-body">
        <div className="dorm-info">
          <Tabs tabs={this.state.showTab ? tabLists : tabList }  page={this.state.tabIndex}
            onChange={(tab: any, index: number) => this.getTab(tab, index)}
          >
            {
              (this.state.tabIndex === 0) ? 
               // 电费
                <div className="dorm-info-mid">
                      {/* 账户余额 */}
                      <Item>
                          <div style={{display:'flex',justifyContent:'space-between',}}>
                            <div className="label">当前余量</div>
                            <div>
                              <div style={{fontSize:'26px'}}>{this.state.rechargeInfo.electric_remain} 度</div>
                              <div style={{fontSize:'12px', color:this.state.rechargeInfo.electric_switch ? '#0066cc' : '#b12d29'}}>
                                { this.state.rechargeInfo.electric_switch ? '正常使用' : '已离线' }
                              </div>
                            </div>
                          </div>
                      </Item>
                      {/* 充值金额 */}
                        <Item>
                          <span className="label">充值金额</span>
                        </Item>
                        <Item className="price_sty" multipleLine={true} wrap={true}>
                          {this.state.usageArr &&
                            this.state.usageArr.map((priceval: any, index: number) => (
                              <span
                                key={priceval}
                                className={this.state.usage === priceval ? 'activeRecharge' : ''}
                                onClick={() => this.getClickVal(index,priceval)}
                              >
                                {priceval}元
                              </span>
                            ))}
                              <div style={{marginTop:'10px'}}>
                                <input  type="number"  pattern="[0-9]*"  style={{marginLeft:'3px',paddingLeft:'8px',height:'42px',width:'95%',border:'1px solid #ccc',borderRadius:'5px'}}
                                  onChange={({ target }: any) => this.getCustomizeVal(target.value)}
                                  placeholder=" 请输入整金额"
                                  value= {this.state.customize}
                                />
                              </div>
                            <div style={{marginTop:'15px',marginLeft:'3px'}}>
                              此次充值电量:{this.getToFixedValue()}度                       
                            </div>
                        </Item>
                        {/* 支付方式 */}
                        <Item>
                            {(this.state.fee_type === 1 &&this.state.rechargeInfo.electric_pay === '1'&&this.state.rechargeInfo.have_electric&&this.state.rechargeInfo.electric_switch) ?
                              <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                <Button className='wx' inline style={{ marginRight: '15px',width:'100px' }} onClick={this.openModal('wechat')}>微信</Button>
                                <Button  className='zfb' inline style={{ width:'100px' }} onClick={this.openModal('alipay')}>支付宝</Button>
                              </div> 
                              : 
                              <div>
                                <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                  <Button disabled  inline style={{ marginRight: '15px',width:'100px' }} >微信</Button>
                                  <Button  disabled  inline style={{ width:'100px' }} >支付宝</Button>
                                </div> 
                              </div>
                            }
                            <Modal
                              visible={this.state.checkModal}
                              transparent
                              maskClosable={false}
                              title=""
                              footer={[{ text: '确定', onPress: () => this.onClose1()() }]}
                            >
                            <div style= {{textAlign:'left',margin:'3px'}}>
                              电表余量查询失败/电表离线，暂时无法进行电表充值操作。如确认该园区允许APP进行电表充值操作，<span style={{color:'#9e091d',fontWeight:800}}>请联系宿舍管理员进行处理</span>。
                            </div>
                            </Modal>
                            <Modal
                              visible={this.state.showModal}
                              transparent
                              maskClosable={false}
                              onClose={this.onClose()}
                              title=""
                              footer={[{ text: '取消', onPress: () => this.onClose()() },{ text: '确定', onPress: () => this.submitPay() }]}
                            >
                            <div style={{marginLeft:'20px'}}>
                              <div style={{display:'flex'}}>
                                  <div style={{color:'#000',fontWeight:800}}>充值类型：</div>
                                  <div>电 费</div>
                              </div>
                              <div style={{display:'flex',marginTop:'15px'}}>
                                <div style={{color:'#000',fontWeight:800}}>充值金额：</div>
                                <div>{this.state.usage}{this.state.usage ?' 元':''}</div>
                              </div>
                              <div style={{display:'flex',marginTop:'15px'}}>
                                <div style={{color:'#000',fontWeight:800}}>充值电量：</div>
                                <div>{this.getToFixedValue()} 度</div>
                              </div>
                            </div>
                            </Modal>
                        </Item>
                    </div> :
                    ((this.state.tabIndex === 1) ? 
                    // 水费
                      <div className="dorm-info-mid">
                          {/* 账户余额 */}
                          <Item>
                              <div style={{display:'flex',justifyContent:'space-between',}}>
                                <div className="label">当前余量</div>
                                <div>
                                  <div style={{fontSize:'26px'}}>{this.state.rechargeInfo.water_remain } 吨</div>
                                  <div style={{fontSize:'12px', color: this.state.rechargeInfo.water_switch? '#0066cc' : '#b12d29'}}>
                                    { this.state.rechargeInfo.water_switch ? '正常使用' : '已离线' }
                                  </div>
                                </div>
                              </div>
                          </Item>
                          {/* 充值金额 */}
                            <Item>
                              <span className="label">充值计量</span>
                            </Item>
                            <Item className="price_sty" multipleLine={true} wrap={true}>
                              {this.state.usageWaterArr &&
                                this.state.usageWaterArr.map((priceval: any, index: number) => (
                                  <span
                                    key={priceval}
                                    className={this.state.usage === priceval ? 'activeRecharge' : ''}
                                    onClick={() => this.getClickVal(index,priceval)}
                                  >
                                    {priceval}吨
                                  </span>
                                ))}
                                  <div style={{marginTop:'10px'}}>
                                    <input  type="number" pattern="[0-9]*"   style={{marginLeft:'3px',paddingLeft:'8px',height:'42px',width:'95%',border:'1px solid #ccc',borderRadius:'5px'}}
                                      onChange={({ target }: any) => this.getCustomizeVal(target.value)}
                                      placeholder=" 请输入整吨数"
                                      value= {this.state.customize}
                                    />
                                  </div>
                                <div style={{marginTop:'15px',marginLeft:'3px'}}>
                                  此次充值金额:{this.getToFixedValue()}元
                                </div>
                            </Item>
                            {/* 支付方式 */}
                            <Item>
                                {(this.state.fee_type === 2 && this.state.rechargeInfo.water_pay === '1'&&this.state.rechargeInfo.have_water&&this.state.rechargeInfo.water_switch) ?
                                  <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                    <Button className='wx' inline style={{ marginRight: '15px',width:'100px' }} onClick={this.openModal('wechat')}>微信</Button>
                                    <Button  className='zfb' inline style={{ width:'100px' }} onClick={this.openModal('alipay')}>支付宝</Button>
                                  </div> 
                                  : 
                                  <div>
                                    <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                      <Button disabled  inline style={{ marginRight: '15px',width:'100px' }} >微信</Button>
                                      <Button  disabled  inline style={{ width:'100px' }} >支付宝</Button>
                                    </div> 
                                  </div>
                                }
                                <Modal
                                  visible={this.state.checkModal}
                                  transparent
                                  maskClosable={false}
                                  title=""
                                  footer={[{ text: '确定', onPress: () => this.onClose1()() }]}
                                >
                                <div style= {{textAlign:'left',margin:'3px'}}>
                                  水表余量查询失败/水表离线，暂时无法进行水表充值操作。如确认该园区允许APP进行水表充值操作，<span style={{color:'#9e091d',fontWeight:800}}>请联系宿舍管理员进行处理</span>。
                                </div>
                                </Modal>
                                <Modal
                                  visible={this.state.showModal}
                                  transparent
                                  maskClosable={false}
                                  onClose={this.onClose()}
                                  title=""
                                  footer={[{ text: '取消', onPress: () => this.onClose()() },{ text: '确定', onPress: () => this.submitPay() }]}
                                >
                                <div style={{marginLeft:'20px'}}>
                                  <div style={{display:'flex'}}>
                                    <div style={{color:'#000',fontWeight:800}}>充值类型：</div>
                                    <div>水 费</div>
                                  </div>
                                  <div style={{display:'flex',marginTop:'15px'}}>
                                    <div style={{color:'#000',fontWeight:800}}>充值金额：</div>
                                    <div>{this.getToFixedValue()} 元</div>
                                  </div>
                                  <div style={{display:'flex',marginTop:'15px'}}>
                                    <div style={{color:'#000',fontWeight:800}}>充值计量：</div>
                                    <div>{this.state.usage}{this.state.usage?' 吨':''}</div>
                                  </div>
                                </div>
                                </Modal>
                            </Item>
                        </div>
                      : 
                      // 热水费
                      <div className="dorm-info-mid">
                      {/* 账户余额 */}
                      <Item>
                          <div style={{display:'flex',justifyContent:'space-between'}}>
                            <div className="label">当前余量</div>
                            <div>
                              <div style={{fontSize:'26px'}}>{this.state.rechargeInfo.hot_remain } 吨</div>
                              <div style={{fontSize:'12px', color: this.state.rechargeInfo.hot_switch? '#0066cc' : '#b12d29'}}>
                                { this.state.rechargeInfo.hot_switch ? '正常使用' : '已离线' }
                              </div>
                            </div>
                          </div>
                      </Item>
                      {/* 充值金额 */}
                        <Item>
                          <span className="label">充值计量</span>
                        </Item>
                        <Item className="price_sty" multipleLine={true} wrap={true}>
                          {this.state.usageWaterArr &&
                            this.state.usageWaterArr.map((priceval: any, index: number) => (
                              <span
                                key={priceval}
                                className={this.state.usage === priceval ? 'activeRecharge' : ''}
                                onClick={() => this.getClickVal(index,priceval)}
                              >
                                {priceval}吨
                              </span>
                            ))}
                              <div style={{marginTop:'10px'}}>
                                <input  type="number" pattern="[0-9]*"   style={{marginLeft:'3px',paddingLeft:'8px',height:'42px',width:'95%',border:'1px solid #ccc',borderRadius:'5px'}}
                                  onChange={({ target }: any) => this.getCustomizeVal(target.value)}
                                  placeholder=" 请输入整吨数"
                                  value= {this.state.customize}
                                />
                              </div>
                            <div style={{marginTop:'15px',marginLeft:'3px'}}>
                              此次充值金额:{this.getToFixedValue()}元
                            </div>
                        </Item>
                        {/* 支付方式 */}
                        <Item>
                            {(this.state.fee_type === 4 && this.state.rechargeInfo.hot_pay === '1'&&this.state.rechargeInfo.have_hot&&this.state.rechargeInfo.hot_switch) ?
                              <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                <Button className='wx' inline style={{ marginRight: '15px',width:'100px' }} onClick={this.openModal('wechat')}>微信</Button>
                                <Button  className='zfb' inline style={{ width:'100px' }} onClick={this.openModal('alipay')}>支付宝</Button>
                              </div> 
                              : 
                              <div>
                                <div style= {{display:'flex',justifyContent:'space-between',margin:'10px'}}>
                                  <Button disabled  inline style={{ marginRight: '15px',width:'100px' }}>微信</Button>
                                  <Button disabled  inline style={{ width:'100px' }}>支付宝</Button>
                                </div>
                              </div>
                            }
                            <Modal
                              visible={this.state.checkModal}
                              transparent
                              maskClosable={false}
                              title=""
                              footer={[{ text: '确定', onPress: () => this.onClose1()() }]}
                              >
                              <div style= {{textAlign:'left',margin:'3px'}}>
                                热水表余量查询失败/热水表离线，暂时无法进行热水表充值操作。如确认该园区允许APP进行热水表充值操作，<span style={{color:'#9e091d',fontWeight:800}}>请联系宿舍管理员进行处理</span>。
                              </div>
                            </Modal>
                            <Modal
                                visible={this.state.showModal}
                                transparent
                                maskClosable={false}
                                onClose={this.onClose()}
                                title=""
                                footer={[{ text: '取消', onPress: () => this.onClose()() },{ text: '确定', onPress: () => this.submitPay() }]}
                              >
                              <div style={{marginLeft:'20px'}}>
                                <div style={{display:'flex'}}>
                                  <div style={{color:'#000',fontWeight:800}}>充值类型：</div>
                                  <div>热水费</div>
                                </div>
                                <div style={{display:'flex',marginTop:'15px'}}>
                                  <div style={{color:'#000',fontWeight:800}}>充值金额：</div>
                                  <div>{this.getToFixedValue()} 元</div>
                                </div>
                                <div style={{display:'flex',marginTop:'15px'}}>
                                  <div style={{color:'#000',fontWeight:800}}>充值计量：</div>
                                  <div>{this.state.usage}{this.state.usage?' 吨':''}</div>
                                </div>
                              </div>
                            </Modal>
                        </Item>
                    </div>
                )}
          </Tabs>
        </div>
      </div>
    )
  }
  getClickVal(key:any, val:any) {
    if (key===0 || key===1 || key===3) {
      this.state.customize = ''
    }
    this.setState({ usage: val })
  }
  // 获取输入值
  getCustomizeVal(val:string) {
    const num = val.split('.')[0]
    this.setState({
      customize: num,
      usage: num,
    });
  }
  getToFixedValue() {
    let val
    if (this.state.fee_type === 1) {
      if(this.state.usage === 0 || Number(this.state.rechargeInfo.ext_electric_fee) === 0) {
        val = 0
      } else {
        val = this.state.usage/Number(this.state.rechargeInfo.ext_electric_fee)
      }
    } else {
      if(this.state.usage === 0 || Number(this.state.rechargeInfo.ext_coldwater_fee) === 0) {
        val = 0
      } else {
        val = this.state.usage*Number(this.state.rechargeInfo.ext_coldwater_fee)
      }
    }
    let adv = val.toString()
    let index = adv.indexOf('.')
    if( index !== -1) {
      adv = adv.substring(0, 2+index+1)
    } else {
      adv = adv.substring(0)
    }
    return Number(adv)
  }
  openModal = (key:any) => (e:any) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      showModal: true,
      pay_type: key,
    });
  }
  onClose = () => () => {
    this.setState({
      showModal: false,
    });
  }
  onClose1 = () => () => {
    this.setState({
      checkModal: false,
    });
  }
  // 调用支付
  async submitPay() {
    if (this.state.fee_type === 1 && Number(this.state.usage) <= 0) {
      Toast.info('充值电费金额必须大于0')
      return
    }
    if (this.state.fee_type === 1 && Number(this.state.rechargeInfo.ext_electric_fee) <= 0) {
      Toast.info('电费单价必须大于0')
      return
    }
    if (this.state.fee_type === 1 && this.getToFixedValue() <= 0) {
      Toast.info('充值电量必须大于0')
      return
    }
    if (this.state.fee_type === 2 && Number(this.state.usage) <= 0) {
      Toast.info('充值水量必须大于0')
      return
    }
    if (this.state.fee_type === 2 && Number(this.state.rechargeInfo.ext_coldwater_fee) <= 0) {
      Toast.info('水费单价必须大于0')
      return
    }
    if (this.state.fee_type === 2 && this.getToFixedValue() <= 0) {
      Toast.info('充值水费金额必须大于0')
      return
    }
    if (this.state.fee_type === 4 && Number(this.state.usage) <= 0) {
      Toast.info('充值热水量必须大于0')
      return
    }
    if (this.state.fee_type === 4 && Number(this.state.rechargeInfo.ext_coldwater_fee) <= 0) {
      Toast.info('热水费单价必须大于0')
      return
    }
    if (this.state.fee_type === 4 && this.getToFixedValue() <= 0) {
      Toast.info('充值热水费金额必须大于0')
      return
    }
    // const backUrl = window.location.href + `?type=${1}`
    const backUrl = window.location.href
    const obj = {
      room_id: this.state.rechargeInfo.room_id,
      bed_id: this.state.rechargeInfo.bed_id,
      phone: cookie.get('sany_phone'),
      store_id: cookie.get('rechargeStoreId'),
      fee_type: this.state.fee_type,
      // 金额
      money: `${this.state.fee_type === 1 ? this.state.usage : this.getToFixedValue() }`,
      // 单价
      price: `${this.state.fee_type === 1 ? this.state.rechargeInfo.ext_electric_fee : this.state.rechargeInfo.ext_coldwater_fee}`, 
      // 充值量
      usage: `${this.state.fee_type === 1 ? this.getToFixedValue(): this.state.usage}`, 
      pay_way: this.state.pay_type, 
      quit_url: backUrl
    }
    if (this.state.pay_type === 'wechat') {
      // 微信支付：从接口获取返回数据
      Toast.loading('加载中...')
      const {data} = await rechargePayApi(obj)
      Toast.hide()
      this.setState({
        showModal: false,
      })
      if (data.code === 'SUCCESS') {
        // const redirectUrl = '&redirect_url=' + encodeURIComponent(backUrl)
        if (data.data && data.data.payinfo.length > 0 && data.data.payinfo.indexOf('https') !== -1) {
          cookie.set('rechargeBillId', data.data.billId)
          if (phonePlatform() === 'iOS') {
            alert('', <div>请确认支付是否完成?</div>, [
              { text: '重新支付', onPress: () => this.resetPay()},
              { text: '支付完成', onPress: () => this.fetchPayResult() },
            ])
          }
          window.location.replace(data.data.payinfo)
        } else if (data.data.payinfo && data.data.payinfo.length > 0) {
          Toast.info(data.data.payinfo)
        } else {
          Toast.info('调用微信支付链接失败,请尝试重新支付~')
        }
      } else {
        Toast.info(data.msg)
      }  
    } else {
      Toast.loading('加载中...')
      const {data} = await rechargePayApi(obj)
      Toast.hide()
      this.setState({
        showModal: false,
      })
      if (data.code === 'SUCCESS') {
        if (data.data && data.data.payinfo.length > 0 && data.data.payinfo.indexOf('<form') !== -1) {
          cookie.set('rechargeBillId', data.data.billId)
          this.props.history.goBack()
          // 支付宝支付：获取接口返回form表单直接提交
          const div = document.createElement('div');
          div.innerHTML = data.data.payinfo;
          document.body.appendChild(div);
          document.forms[0].submit();
        } else if (data.data && data.data.payinfo.length > 0) {
          Toast.info(data.data.payinfo)
        } else {
          Toast.info('调用支付宝链接失败,请尝试重新支付~')
        }
      } else {
        Toast.info(data.msg)
      }
    }
  }
  async resetPay() {
    const billId = cookie.get('rechargeBillId')
    Toast.loading('加载中...')
    await RechargeResultApi({billId})
    Toast.hide()
    cookie.set('rechargeBillId', '')
    // cookie.set('activeTab', '')
  }
  async fetchPayResult() {
    const billId = cookie.get('rechargeBillId')
    Toast.loading('加载中...')
    const {data} = await RechargeResultApi({billId})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      // 支付成功 未支付
      this.props.history.push({
        pathname: '/sany/recharge-history'
      })
    } else {
      Toast.info(data.msg)
    }
    // 因为支付宝支付需要提前跳转至宿舍管理dorm-manage页面  所以不能在那里清空cookie
    cookie.set('rechargeBillId', '')
    cookie.set('activeTab', '')
  }
  render() {
    return (
      <div className="recharge">
        <NoticeBar mode="closable" marqueeProps={{ loop: true }}>温馨提示：更换后的水电表，表上数据均为总用水/电量，非余额/余量。</NoticeBar>
        {this.payInfoList()}
      </div>
    )
  }
}
